import { useRef, useState } from 'react';
import LoadingButton from '@enerex/unified-ui-react/LoadingButton';
import Popover from '@enerex/unified-ui-react/PopoverV2';
import CloseIcon from '@enerex/unified-ui-react/icons/CloseIcon';

const VISIBLE_ALIAS_LIMIT = 10;

const LookupAliases = ({ value, recordName }) => {
    const [open, setOpen] = useState(false);
    const trigger = useRef(null);
    const aliases = String(value ?? '').split(/[;,]/).map(alias => alias.trim()).filter(Boolean);
    if (!aliases.length) return '—';
    const title = `Aliases for ${recordName}`;
    const close = () => { setOpen(false); trigger.current?.focus(); };
    return <div className="settings-lookup__aliases">
        {aliases.slice(0, VISIBLE_ALIAS_LIMIT).map((alias, index) => <span key={index} className="settings-lookup__alias-tag" title={alias}>{alias}</span>)}
        {aliases.length > VISIBLE_ALIAS_LIMIT && <Popover trigger="click" placement="bottom-start" show={open} onOpenChange={setOpen}
            popoverProps={{ className: 'settings-lookup__alias-popover', 'aria-label': title }}
            title={<span className="settings-lookup__alias-heading"><span>{title}</span>
                <LoadingButton type="button" variant="link" className="settings-lookup__alias-close" aria-label="Close aliases" onClick={close}><CloseIcon aria-hidden="true" /></LoadingButton>
            </span>}
            body={<ul className="settings-lookup__alias-list">{aliases.map((alias, index) => <li key={index}>{alias}</li>)}</ul>}>
            <LoadingButton ref={trigger} type="button" variant="link" className="settings-lookup__alias-more"
                aria-label={`Show all ${aliases.length} aliases for ${recordName}`}>
                +{aliases.length - VISIBLE_ALIAS_LIMIT} more
            </LoadingButton>
        </Popover>}
    </div>;
};
export default LookupAliases;
